import React, { useEffect } from 'react';
import Footer from '../components/Footer';

function TermsOfService() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <main className="legal-page">
        <div className="container">
          <h1 className="legal-page__title">Terms of Service</h1>
          <p className="legal-page__updated">Last updated: March 2026</p>

          <section className="legal-page__section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using the KBY Interactive website, you accept and agree to be bound by these Terms of Service. If you do not agree, please do not use our website.</p>
          </section>

          <section className="legal-page__section">
            <h2>2. Services</h2>
            <p>KBY Interactive Co., Ltd. provides creative technology services including but not limited to: interactive installations, immersive experiences, web development, virtual solutions, generative AI, and IoT/hardware integration.</p>
          </section>

          <section className="legal-page__section">
            <h2>3. Intellectual Property</h2>
            <p>All content on this website, including text, graphics, logos, images, videos, and software, is the property of KBY Interactive Co., Ltd. and is protected by Thai and international copyright laws. You may not reproduce, distribute, or create derivative works without our prior written consent.</p>
          </section>

          <section className="legal-page__section">
            <h2>4. Use of Website</h2>
            <p>You agree to use our website only for lawful purposes and in a manner that does not infringe upon the rights of others. You may not:</p>
            <ul>
              <li>Use our website for any illegal or unauthorized purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper operation of the website</li>
              <li>Copy or scrape content without permission</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>5. Project Agreements</h2>
            <p>Specific terms for individual projects will be outlined in separate project agreements or contracts. These Terms of Service serve as general guidelines for website usage only.</p>
          </section>

          <section className="legal-page__section">
            <h2>6. Limitation of Liability</h2>
            <p>KBY Interactive shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our website or services.</p>
          </section>

          <section className="legal-page__section">
            <h2>7. Governing Law</h2>
            <p>These Terms of Service are governed by the laws of the Kingdom of Thailand. Any disputes shall be resolved in the courts of Thailand.</p>
          </section>

          <section className="legal-page__section">
            <h2>8. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. Changes will be posted on this page with an updated revision date.</p>
          </section>

          <section className="legal-page__section">
            <h2>9. Contact</h2>
            <p>For questions regarding these Terms of Service:</p>
            <p>
              <strong>KBY Interactive Co., Ltd.</strong><br />
              Email: thitisquall@gmail.com<br />
              Phone: 063-782-4516
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default TermsOfService;
